import React, { useEffect, useMemo, useState } from "react";
import { useIntl } from "react-intl";
import {
  OutlineButton,
  PrimaryButton,
} from "../../../components/barbagli/common";
import { SearchBar } from "../../../components/barbagli/search_bar";
import { SortableTableView } from "../../../components/barbagli/sortable_table_view";
import { TabView } from "../../../components/barbagli/tab_view";
import { FilterParam, OrderParam } from "../../../models/barbagli/filter_order";
import { Attributes, emptyMeter, Meter } from "../../../models/meter";
import { fetchPaginatedCollection } from "../../../repsitory/generic_repository";
import { history } from "../../../index";
import { deepCopy } from "../../../utils/deep_copy";
import { Title } from "../../../components/barbagli/text";
import { showFileUploader } from "components/file_uploader/file_uploader_component";
import { translate } from "utils/intl";
import { useLocation } from "react-router-dom";
import { TypeAuthorized } from "components/authorized";
import { MeterWhiteListTable } from "./MeterWhiteListTable";

type Props = {
  onClick?: (m: Meter) => void;
  gateway_id?: number;
  filters?: FilterParam[];
  visibleFilters?: FilterParam[];
  selfReading?: boolean;
};

type MetersIndexState = {
  selected_tab: "RIPARTITORE" | "AF" | "ACS" | "CALORIE" | "FRIGORIE";
};

export function WhiteListMeters(props: Props) {
  const [state, setState] = useState<MetersIndexState>({ selected_tab: "AF" });
  useEffect(() => {
    console.log("statik", state);
  }, [state]);

  return (
    <div>
      <ViewForState
        tab={"AFACS"}
        state={state}
        setState={setState}
        {...props}
      />
      ,
    </div>
  );
}

function ViewForState(props: {
  tab: string;
  state: MetersIndexState;
  gateway_id?: number;
  setState: React.Dispatch<React.SetStateAction<MetersIndexState>>;
  onClick?: (m: Meter) => void;
  filters?: FilterParam[];
  visibleFilters?: FilterParam[];
  selfReading?: boolean;
}) {
  const [order, setOrder] = useState<OrderParam>({
    column: "id",
    order: "asc",
  });
  const [selectedFilters, setSelectedFilters] = useState<any[]>([]);

  const intl = useIntl();

  useEffect(() => {
    console.log("vpizduu", props);
  });

  useEffect(() => {
    if (props?.filters && props.filters.length > 0) {
      if (props?.tab == "AFACS") {
        setSelectedFilters(props?.filters?.[0]?.filters || []);
      }
    }
  }, [props]);

  useEffect(() => {
    console.log("seliuk", selectedFilters);
  }, [selectedFilters]);

  const handleFiltersChange = (searchFilters: FilterParam[]) => {
    if (!props.filters || props.filters.length === 0) {
      setSelectedFilters([]);
      return;
    }

    const allFilters = props.filters[0]?.filters || [];

    if (searchFilters.length === 0) {
      const sorted = allFilters.sort((a: any, b: any) => {
        const manufacturerA = (a.manufacturer || "").toString().toLowerCase();
        const manufacturerB = (b.manufacturer || "").toString().toLowerCase();
        const manufacturerCompare = manufacturerA.localeCompare(manufacturerB);

        if (manufacturerCompare === 0) {
          const addressA = (a.address || "").toString();
          const addressB = (b.address || "").toString();

          const numA = parseFloat(addressA);
          const numB = parseFloat(addressB);

          if (!isNaN(numA) && !isNaN(numB)) {
            return numA - numB;
          }

          return addressA.localeCompare(addressB);
        }

        return manufacturerCompare;
      });
      setSelectedFilters(sorted);
      return;
    }

    const filtered = allFilters.filter((item: any) => {
      return searchFilters.every((searchFilter) => {
        const itemValue = item[searchFilter.column];
        if (!itemValue) return false;

        return itemValue
          .toString()
          .toLowerCase()
          .includes(searchFilter.value.toLowerCase());
      });
    });

    setSelectedFilters(filtered);
  };

  return (
    <div className="d-flex flex-column">
      {props.selfReading && (
        <h2>{intl.messages["select_meter_for_self_reading"]}</h2>
      )}

      <SearchBar
        filters={[]}
        avaliableFilters={["manufacturer", "address", "version", "type"]}
        filterNamePostProcessor={(id) => intl.messages[id]?.toString() ?? id}
        onFiltersChange={handleFiltersChange}
      />

      <TypeAuthorized
        user_types={[
          "admin",
          "company-admin",
          "partner-admin",
          "installer",
          "mnd-user",
        ]}
      >
        <>
          <MeterWhiteListTable selectedFilters={selectedFilters} />

          {!props.onClick && (
            <div className="d-flex flex-row-reverse">
              <OutlineButton
                style={{ marginLeft: 8 }}
                onClick={() => {
                  showFileUploader("/api/v1/meter/import");
                }}
              >
                {intl.messages["Create from Csv"]?.toString() ??
                  "Create from Csv"}
              </OutlineButton>

              <PrimaryButton
                onClick={() => {
                  history.push("/meters/new", null);
                }}
              >
                {intl.messages["add_meter"]}
              </PrimaryButton>
            </div>
          )}
        </>
      </TypeAuthorized>
    </div>
  );
}
